/* global axios */

import ApiClient from './ApiClient';

class TelegramApiClient extends ApiClient {
  constructor() {
    super('telegram_api', { accountScoped: true });
  }

  initiate(data) {
    return axios.post(`${this.url}/initiate`, data);
  }

  requestQr(data) {
    return axios.post(`${this.url}/request_qr`, data);
  }

  verifyCode(data) {
    return axios.post(`${this.url}/verify_code`, data);
  }

  verifyPassword(data) {
    return axios.post(`${this.url}/verify_password`, data);
  }

  getStatus(channelId) {
    return axios.get(`${this.url}/status`, {
      params: { channel_id: channelId },
    });
  }

  disconnect(data) {
    return axios.post(`${this.url}/disconnect`, data);
  }

  getChats(channelId) {
    return axios.get(`${this.url}/chats`, {
      params: { channel_id: channelId },
    });
  }

  selectChats(data) {
    return axios.post(`${this.url}/select_chats`, data);
  }

  fetchChatMembers({ channelId, chatId }) {
    return axios.post(`${this.url}/fetch_chat_members`, {
      channel_id: channelId,
      chat_id: chatId,
    });
  }

  getChatMembers({ channelId, chatId }) {
    return axios.get(`${this.url}/chat_members`, {
      params: { channel_id: channelId, chat_id: chatId },
    });
  }

  backfill({ channelId, chatIds, sinceDays }) {
    return axios.post(`${this.url}/backfill`, {
      channel_id: channelId,
      chat_ids: chatIds,
      since_days: sinceDays,
    });
  }

  getBackfillStatus(channelId) {
    return axios.get(`${this.url}/backfill_status`, {
      params: { channel_id: channelId },
    });
  }
}

export default new TelegramApiClient();
